module.exports = __webpack_public_path__ + "static/img/RAPW450_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPW450_1.png
// module id = EM8Z
// module chunks = 0